/* Blitzz Salarié — règles hors ligne : mises à jour optimistes du cache + actions non différables + pré-chargement. */
import { kvPatch } from "./db";
import { prefetchUrls } from "./offlineApi";

const now = () => new Date().toISOString();
const me = () => { try { return JSON.parse(localStorage.getItem("blitzz_user_cache") || "null"); } catch { return null; } };

/** Actions impossibles hors ligne (OTP SMS/WhatsApp, upload) → erreur explicite plutôt que file d'attente. */
export const SALARIE_NO_QUEUE = [/^\/tracking\/punch\/(start|stop|verify)$/, /^\/integrations\/callmebot\//, /^\/messages\/attachments\//, /^\/messages\/conversations$/];

/** Applique l'effet d'une mutation mise en file d'attente sur les données en cache (lecture immédiate cohérente). */
export async function salarieOptimistic({ method, url, body = {}, client_id }) {
  let m;
  if ((m = url.match(/^\/personal\/tasks\/([^/]+)$/))) {
    const id = m[1];
    if (method === "delete") return kvPatch("/personal/tasks", (l) => (l || []).filter((t) => t.task_id !== id));
    return kvPatch("/personal/tasks", (l) => (l || []).map((t) => (t.task_id === id ? { ...t, ...body, updated_at: now(), pending_sync: true } : t)));
  }
  if (method === "post" && url === "/personal/tasks") {
    return kvPatch("/personal/tasks", (l) => [{ task_id: client_id, status: "todo", priority: "medium", ...body, created_at: now(), pending_sync: true }, ...(l || [])]);
  }
  if (method === "post" && (m = url.match(/^\/messages\/(conv_[^/]+)$/))) {
    const cid = m[1];
    const u = me();
    const msg = { message_id: client_id, conversation_id: cid, sender_id: u?.user_id, sender_name: u?.name || "", content: body.content || "", attachments: [], read: false, created_at: now(), pending_sync: true };
    await kvPatch(`/messages/${cid}`, (l) => [...(l || []), msg]);
    return kvPatch("/messages/conversations", (l) => (l || []).map((c) => (c.conversation_id === cid ? { ...c, last_message: body.content || "", last_message_at: msg.created_at } : c)));
  }
  if (method === "put" && (m = url.match(/^\/notifications\/([^/]+)\/read$/))) {
    const id = m[1];
    return kvPatch("/notifications", (l) => (l || []).map((n) => (n.notification_id === id ? { ...n, read: true } : n)));
  }
  if (method === "put" && url === "/notifications/read") {
    const ids = new Set(body.ids || []);
    return kvPatch("/notifications", (l) => (l || []).map((n) => (body.all || ids.has(n.notification_id) ? { ...n, read: true } : n)));
  }
  return null;
}

/** Télécharge en cache tout ce qu'il faut pour travailler hors ligne dans l'app Salarié. */
export async function prepareSalarieOffline(api, onProgress = () => {}) {
  const base = ["/notifications", "/notifications/counts", "/messages/conversations", "/messages/unread/count", "/personal/tasks", "/personal/summary", "/payroll/my/payslips", "/personal/documents", "/personal/folders", "/integrations/callmebot/me", "/me/app-config"];
  const u = me();
  if (u?.user_id) base.push(`/tracking/employees/${u.user_id}/summary?days=30`);
  base.push("/tracking/employees/me/schedule");
  let convos = [];
  try { convos = (await api.get("/messages/conversations")).data || []; } catch { /* hors ligne */ }
  const urls = [...base, ...convos.slice(0, 30).map((c) => `/messages/${c.conversation_id}`)];
  const n = await prefetchUrls(api, urls, onProgress);
  return { urls: n, conversations: convos.length, at: Date.now() };
}
